import React from 'react';

import { MdDelete, MdModeEdit } from "react-icons/md";

import Button from "../shared/Button";
import Definition from "../shared/Definition";
import Flex from "../shared/Flex";
import moment from "moment";

class ProjectSummary extends React.Component {
  render() {
    return (
      <div>
        <Definition>Description</Definition>
        {this.props.projectData.description}

        <Definition>Created</Definition>
        {moment(this.props.projectData.modifiedAt).format('hh:mm o\nn dddd d MMMM YYYY')}

        <Definition>Project ID</Definition>
        {this.props.projectData.ID}

        <Definition>CityCAD models</Definition>
        {this.props.projectData.resourcesCount}

        <Definition>Permissions</Definition>
        {(this.props.projectData.isCanEdit === "1") && 'You can view and edit this project'}
        {(this.props.projectData.isCanView === "1" && this.props.projectData.isCanEdit === "0") && 'You can view this project'}
        {this.props.projectData.isCanEdit === "1" && <hr />}
        {
          this.props.projectData.isCanEdit === "1"
          &&
          <Flex>
            <Button small onClick={this.props.toggleEditProjectForm}>
              <Flex style={{justifyContent:"flex-start"}}>
                <MdModeEdit size={16} style={{marginRight:"10px"}} />
                <span>Edit project</span>
              </Flex>
            </Button>
            <Button small onClick={this.props.toggleDeleteProjectConfirmation}>
              <Flex style={{justifyContent:"flex-start"}}>
                <MdDelete size={16} style={{marginRight:"10px"}} />
                <span>Delete project</span>
              </Flex>
            </Button>
          </Flex>
        }
      </div>
    )
  }
};

export default ProjectSummary;
